export class FileCardUtils {
  /** Short, human label for a file-card's second line (e.g. "PDF", "Image", "DOCX") instead of a raw mime type. */
  static typeLabel(fileType: string | null | undefined, name: string | null | undefined): string {
    const mime = (fileType || "").toLowerCase();
    if (mime.includes("pdf")) return "PDF";
    if (mime.startsWith("image/")) return "Image";
    const ext = (name || "").split(".").pop();
    return ext && ext.length <= 5 ? ext.toUpperCase() : "File";
  }

  static formatFileSize(bytes: number | null | undefined): string {
    if (!bytes) return "";
    const units = ["B", "KB", "MB", "GB"];
    let value = bytes;
    let unitIndex = 0;
    while (value >= 1024 && unitIndex < units.length - 1) {
      value /= 1024;
      unitIndex++;
    }
    return `${value.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
  }
}
